const LAUNCHER_SIZE = 88;
const EDGE_INSET = 24;
const MOBILE_EDGE_INSET = 16;
const MOBILE_BREAKPOINT = 576;
const DRAG_THRESHOLD = 6;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const clampLauncherPosition = (position, viewport) => ({
    x: clamp(
        Math.round(position.x),
        0,
        Math.max(0, Math.floor(viewport.width) - LAUNCHER_SIZE)
    ),
    y: clamp(
        Math.round(position.y),
        0,
        Math.max(0, Math.floor(viewport.height) - LAUNCHER_SIZE)
    ),
});

const getDefaultLauncherPosition = (viewport) => {
    const inset = viewport.width < MOBILE_BREAKPOINT ? MOBILE_EDGE_INSET : EDGE_INSET;

    return clampLauncherPosition({
        x: viewport.width - LAUNCHER_SIZE - inset,
        y: viewport.height - LAUNCHER_SIZE - inset,
    }, viewport);
};

const hasExceededDragThreshold = (startPoint, point) => {
    const deltaX = point.x - startPoint.x;
    const deltaY = point.y - startPoint.y;

    return (deltaX * deltaX) + (deltaY * deltaY) > DRAG_THRESHOLD * DRAG_THRESHOLD;
};

module.exports = {
    LAUNCHER_SIZE,
    getDefaultLauncherPosition,
    clampLauncherPosition,
    hasExceededDragThreshold,
};
